export const LOGIN = 'LOGIN';
export const CHECK_AUTO_SIGNIN = 'CHECK_AUTO_SIGNIN';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const API_FAILED = 'API_FAILED';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
